import { TColors } from '@cian/ui-kit-design-tokens/colors';
import { TDeprecatedColors } from '@cian/ui-kit-design-tokens/colors/deprecated';
import * as React from 'react';

interface IIconBooking16Props {
  color: TColors | TDeprecatedColors;
}

export const IconBooking16: React.FC<IIconBooking16Props> = ({ color }) => {
  const fill = `var(--${color})`;

  return (
    // eslint-disable-next-line react/forbid-elements
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_674_30059)">
        <path d="M13.6057 15.0208L9.10571 10.5208L10.5198 9.10669L15.0198 13.6067L13.6057 15.0208Z" fill={fill} />
        <path d="M3.76 2.47999L2.48 3.75999L4.4 5.67999L5.68 4.39999L3.76 2.47999Z" fill={fill} />
        <path d="M2.48 12.72L4.4 10.8L5.68 12.08L3.76 14L2.48 12.72Z" fill={fill} />
        <path d="M10.8 4.39999L12.72 2.47999L14 3.75999L12.08 5.67999L10.8 4.39999Z" fill={fill} />
        <path d="M3.71449 7.33493H0.999198L0.999198 9.14513L3.71449 9.14513V7.33493Z" fill={fill} />
        <path d="M7.33488 0.999256L9.14507 0.999256L9.14507 3.71455L7.33488 3.71455V0.999256Z" fill={fill} />
        <path d="M6.27521 6.27447L8.83521 13.9545L10.5034 10.5027L13.9552 8.83447L6.27521 6.27447Z" fill={fill} />
      </g>
      <defs>
        <clipPath id="clip0_674_30059">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
